module.exports = __webpack_public_path__ + "img/spe4.bf70b265.jpg";